import apiClient from "@/libs/axios";
import router from '@/router';

console.log("categories module registered.");
export const state = {
    data: [],
    details: null,
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    setDetails: (state, data) => {
        state.details = data.result;
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, is_active: data.is_active} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {
    async get({ commit }, data) {

        const filters = window.mapFilterData(data);

        await apiClient
            .get(`api/v1/categories${filters}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async toggle({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .post(`api/v1/categories/toggle`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data);
                    commit('app/loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                throw error;
            },);
        commit('app/loadingFinish', null, {root: true});
    },

    async create({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .post(`api/v1/categories/create`, data)
            .then(response => {
                console.log(response.data)
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async details({ commit }, data) {
        await apiClient
            .get(`api/v1/categories/show?id=${data.id}`)
            .then(response => {
                console.log(response)
                if (response.status === 200) {
                    commit('setDetails', response.data)
                }
            })
            .catch(error => {
                throw error;
            })
    },

    async update({ commit }, data) {
        await apiClient
            .patch(`api/v1/categories/update`, data)
            .then(response => {
                console.log(response.data)
                commit('updateData', data.result)
                router.push('/service-categories')
            })
            .catch(error => {
                throw error
            });
    },

    async delete({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .delete(`api/v1/categories/delete?id=${data.id}`)
            .then(response => {
                console.log(response);
                commit('deleteItem', data.id);
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            });
    },
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getDetails(state) {
        return state.details;
    },
    getTotal(state) {
        return state.total;
    },
};
